<form>
   <div class="sam-form-row">
      <label>{{ 'common.global_settings.titles.brick_scaling' | translate }}</label>
      <div>
         <kendo-slider
            [disabled]="!(isFeatureEnabled$ | async)"
            class="k-form-field sam-form-control sam-form-control-full-width"
            [showButtons]="false"
            [fixedTickWidth]="10"
            [min]="15"
            [max]="250"
            [smallStep]="5"
            [value]="brickScaling$ | async"
            (valueChange)="brickScalingChanged($event)"
            fxFlex="1 1 90%"
         >
         </kendo-slider>
         <div class="sam-margin-left" fxFlexAlign="center" fxFlex="1 1 auto">{{ brickScaling$ | async }}%</div>
      </div>
   </div>

   <div class="sam-form-row">
      <label>{{ 'common.brick_wall_settings.titles.brick-margin' | translate }}</label>
      <kendo-numerictextbox
         [disabled]="!(isFeatureEnabled$ | async)"
         class="k-form-field sam-form-control sam-form-control-full-width"
         [value]="getBrickWallMargin$ | async"
         [min]="0"
         [max]="25"
         format="n0"
         (valueChange)="changeBrickWallMargin($event)"
      ></kendo-numerictextbox>
   </div>

   <div class="sam-form-row">
      <label>{{ 'common.global_settings.titles.background_image' | translate }}</label>
      <div class="k-form-field k-form-field-with-icon sam-form-control sam-form-control-full-width">
         <input
            [disabled]="!(isFeatureEnabled$ | async)"
            (input)="backgroundImageChanged($event.target.value)"
            [value]="backgroundImage$ | async"
            fxFlex="1 1 auto"
            kendoTextBox
         />
         <fa-icon
            [icon]="cancelIcon"
            *ngIf="(backgroundImage$ | async) && (backgroundImage$ | async).length > 0"
            (click)="backgroundImageChanged('')"
            flip="horizontal"
         ></fa-icon>
      </div>
   </div>
</form>
